<!-- Klarna-提交抗辩 -->
<template>
  <el-drawer
    v-loading="cardLoading"
    size="100vh"
    :visible.sync="visible"
    :close-on-press-escape="false"
    :show-close="false"
    :direction="'ttb'"
    :before-close="handleClose">
    <template #title>
      <div class="header">
        <div class="header-left">
          <div class="close-btn">
            <img @click="handleClose" src="./image/icon-close2x.png" alt="" />
          </div>
          <div class="header-text">{{ $t('message.refuse.klarnaRebutDrawer.title') }}</div>
        </div>

        <div class="header-right" v-if="!disabled">
          <el-button class="default-btn" :loading="btnLoading.saveDraft" size="small" type="default" @click="handleSubmit(true)">{{$t("message.refuse.klarnaRebutDrawer.saveDraft")}}</el-button>
          <el-button class="primary-btn" v-show="currSection === 1" size="small" type="primary" @click="handleNext" >{{$t("message.refuse.klarnaRebutDrawer.nextStep")}}</el-button>
          <el-button class="default-btn" v-show="currSection === 2" size="small" type="primary" @click="handlePrev" >{{$t("message.refuse.klarnaRebutDrawer.prevStep")}}</el-button>
          <el-button class="primary-btn" :loading="btnLoading.submit"  v-show="currSection === 2" size="small" type="primary" @click="handleSubmit(false)" >{{$t("message.refuse.klarnaRebutDrawer.submit")}}</el-button>
        </div>
      </div>
    </template>

    <div class="rebut-container">
        <chargeback-info class="chargeback-info" :data="detail.chargeback"/>

        <!-- 编辑 -->
        <div class="layer" :class="{'overFormStyle': !disabled}">
          <section-one
            ref="sectionOne"
            v-show="disabled || (!disabled && currSection === 1)"
            class="section"
            :txnInfo="detail.txnInfo"
            :disabled="disabled"
            :refundList="detail.refundList"
            :data="submitParam"
            @update:data="submitParam = $event"
          ></section-one>
          <section-two
            ref="sectionTwo"
            class="section"
            v-show="disabled || (!disabled && currSection === 2)"
            :disabled="disabled"
            :id="id"
            :goodType="submitParam.shipping?.goodType"
            :shippingFileList="shippingFileList"
            :otherFileList="otherFileList"
            @update:shippingFileList="shippingFileList = $event"
            @update:otherFileList="otherFileList = $event"
          ></section-two>
        </div>
    </div>

    <custom-message
      ref="customMessage"
      :closeOnPressEscape="false"
      :closeOnClickModal="false"
      :distinguishCancelAndClose="true"
      :showClose="false"
      cancelButtonText="message.refuse.klarnaRebutDrawer.leave.confirmText"
      confirmButtonText="message.refuse.klarnaRebutDrawer.leave.cancelText"
      customClass="close"
     ></custom-message>

  </el-drawer>
</template>

<script>
import CustomMessage from '@/components/modal/message-box/custom-message.vue';
import { ShowSuccessMessage } from '@/components/modal/tips/message-tips';
import { shallowClones, scrollToErrorDom } from '@/utils/tools/utils';
import AppealService from '@/views/transaction/api/appeal-manage.service';
import ChargebackInfo from '@/views/transaction/refuse-manage/klarna-rebut/components/chargeback-info/index.vue';
import SectionOne from '@/views/transaction/refuse-manage/klarna-rebut/components/section-one/index.vue';
import SectionTwo from '@/views/transaction/refuse-manage/klarna-rebut/components/section-two/index.vue';
export default {
  components: {
    ChargebackInfo,
    SectionOne,
    SectionTwo,
    CustomMessage,
  },
  data() {
    return {
      id: '',
      visible: false,
      disabled: false,
      detail: {},
      cardLoading: false,
      currSection: 1,
      // 交易信息
      txnInfo: {},
      originSubmitParam: {},
      submitParam: {
        appealExplain: '',
        product: {},
        customer: {
          billingAddress: {},
        },
        shipping: {
          shippingAddress: {},
        },
      },
      // 物流文件
      shippingFileList: [],
      // 其他文件
      otherFileList: [],
      // 已经暂存过
      isSaveDraft: false,
      btnLoading: {
        saveDraft: false,
        submit: false,
      },
    };
  },
  methods: {
    scrollToErrorDom,
    /**
     * first: 没有提交过，需要回显原信息中的默认值 传入的data 是getChargebackInfo接口的完整数据
     * draft: 提交过（暂存了），需要回显暂存的值
     * view: 正式提交完成后预览，只需要拿接口专门提供的appealInfo
     */
    async init(type) {
      const initData = () => {
        return new Promise((resolve) => {
          this.submitParam = {
            appealExplain: '',
            product: {},
            customer: {
              billingAddress: {},
            },
            shipping: {
              goodType: undefined,
              shippingAddress: {},
            },
          };
          this.originSubmitParam = {};
          this.shippingFileList = [];
          this.otherFileList = [];
          this.btnLoading = {
            saveDraft: false,
            submit: false,
          };
          this.isSaveDraft = false;

          const _appealInfo = type === 'view' ? this.detail.chargeback : this.detail.chargeback.appealInfoDraft;

          this.submitParam = {
            // ..._appealInfo.appealInfo,
            product: {
              ..._appealInfo.appealInfo.product,
            },
            customer: {
              billingAddress: {},
              ..._appealInfo.appealInfo.customer,
            },
            shipping: {
              goodType: undefined,
              shippingAddress: {},
              ..._appealInfo.appealInfo.shipping,
            },
            appealExplain: type === 'view' ? this.detail.chargeback.appealExplain : _appealInfo.appealExplain,
          };

          if (type === 'view') {
            this.shippingFileList = this.detail.fileList.filter(file => file.fileType === '5' || file.fileType === '6');
            this.otherFileList = this.detail.fileList.filter(file => file.fileType !== '5' && file.fileType !== '6');
          } else {
            if (_appealInfo?.fileList?.length) {
              this.shippingFileList = _appealInfo?.fileList?.filter(file => file.fileType === '5' || file.fileType === '6') || [];
              this.otherFileList = _appealInfo?.fileList?.filter(file => file.fileType !== '5' && file.fileType !== '6') || [];
            }
          }
          resolve(true);
        });
      };

      await initData();
      if (type !== 'view') {
        this.clearValidate();
      }
    },
    async open(id, isDisable = false) {
      this.resetState(id, isDisable);
      await this.getData(id);

      const initType = this.disabled ? 'view' : this.detail.chargeback.appealInfo ? 'draft' : 'first';
      await this.init(initType);
      this.originSubmitParam = shallowClones(this.submitParam);
    },
    resetState(id, isDisable) {
      this.id = id;
      this.visible = true;
      this.disabled = isDisable;
      this.cardLoading = true;
      this.currSection = 1;
    },
    // 关闭弹窗
    // 只有修改过值且没有暂存过，才会出现挽留弹窗
    handleClose() {
      // 如果没有修改过，直接关闭（查看详情肯定也会返回true）
      if (this.deepEqual(this.originSubmitParam, this.submitParam)) {
        this.visible = false;
      } else {
        this.isSaveDraft ? this.visible = false : this.showLeaveConfirmation();
      }
    },
    // 获取详情
    async getData(id) {
      try {
        this.detail = await AppealService.getChargebackInfo(id);
      } finally {
        this.cardLoading = false;
      }
    },
    handlePrev() {
      this.currSection = 1;
    },
    async handleNext() {
      await this.validateSection(1) && (this.currSection = 2);
    },

    // 校验表单
    async validateSection(step) {
      const section = step === 1 ? 'sectionOne' : 'sectionTwo';
      return this.$refs[section]?.validate()?.catch(() => {
        this.scrollToErrorDom();
        return false;
      });
    },

    async handleSubmit(isSaveDraft = false) {
      // 如果需要暂存 则不校验
      // 提交时已经走到第二步了 只需要校验第二步
      if (!isSaveDraft && !(await this.validateSection(2))) return;
      await this.submit(isSaveDraft);
    },

    // 提交
    async submit(isSaveDraft = false) {
      const param = {
        id: this.id,
        appealExplain: this.submitParam.appealExplain,
        fileList: [...this.shippingFileList, ...this.otherFileList],
        appealInfo: {
          ...this.submitParam,
          draft: isSaveDraft,
        },
      };

      try {
        this.btnLoading[isSaveDraft ? 'saveDraft' : 'submit'] = true;
        const saveFn = isSaveDraft ? AppealService.draftSubmitAppeal : AppealService.postSubmitAppeal;
        const res = await saveFn(param);
        if (res) {
          ShowSuccessMessage(this.$t('message.submitSuccessfulTip'));
        }
        if (isSaveDraft) {
          this.isSaveDraft = true;
        }
        // 只有提交才关闭弹窗
        if (res && !isSaveDraft) {
          this.visible = false;
          this.$emit('success');
        }
      } finally {
        this.btnLoading[isSaveDraft ? 'saveDraft' : 'submit'] = false;
      }
    },

    // 清除表单校验
    clearValidate() {
      this.$refs.sectionOne.clearValidate();
    },

    // 挽留弹窗
    showLeaveConfirmation() {
      this.$refs.customMessage.openDefaultModal(
        {
          contentHtml: this.$t('message.refuse.klarnaRebutDrawer.leave.content'),
          titleHtml: this.$t('message.refuse.klarnaRebutDrawer.leave.title'),
          showClose: false,
          onCallback: action => {
            if (action !== 'confirm') this.visible = false;
          },
        },
        'color-new',
      );
    },

    // 深比较
    deepEqual(obj1, obj2) {
      if (obj1 === obj2) return true;

      if (typeof obj1 !== 'object' || obj1 === null || typeof obj2 !== 'object' || obj2 === null) {
        return obj1 === obj2;
      }

      const keys1 = Object.keys(obj1);
      const keys2 = Object.keys(obj2);

      if (keys1.length !== keys2.length) return false;

      for (const key of keys1) {
        if (!keys2.includes(key) || !this.deepEqual(obj1[key], obj2[key])) {
          return false;
        }
      }

      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
:deep(.el-drawer__header) {
  padding: 0;
  margin: 0;
}

:deep(.el-drawer__body) {
  background-color: #FBFBFD;
}

:deep(.el-icon-close) {
  background-color: red !important;
}

:deep(.el-select__caret) {
  color: #a9a9a9 !important;
}

.overFormStyle:deep(.el-textarea__inner) {
  background-color: #fff !important;
  color: #1A202C !important;
}
.overFormStyle:deep(.el-input__inner) {
  background-color: #fff !important;
  color: #1A202C !important;
}

.header {
  height: 38px;
  padding: 20px 80px 20px 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #EDF1F7;
  background-color: #FBFBFD;
  .header-left {
    display: flex;
    align-items: center;
    .close-btn {
      margin-right: 32px;
      display: flex;
      align-items: center;
      img {
        transition: all 0.3s ease;
        transform-origin: center;
        width: 24px;
        height: 24px;
        cursor: pointer;
        &:hover {
          transform: rotate(180deg) scale(1.2);
        }
      }
    }

    .header-text {
      width: 300px;
      height: 38px;
      font-family: Open Sans, Open Sans;
      font-weight: bold;
      font-size: 18px;
      color: #1A202C;
      line-height: 38px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
  }
}

.default-btn {
  padding: 8px 24px;
  background-color: #fff;
  border-radius: 8px 8px 8px 8px;
  border: 1px solid #D0D5DD;
  color: #000000;
  font-weight: 400;
  &:hover {
    background: #F6F6FF;
    border: 1px solid $color-primary-purple;
    color: $color-primary-purple;
  }
}

.primary-btn {
  padding: 8px 24px;
  background-color: #fff;
  border-radius: 8px 8px 8px 8px;
  border: 0 !important;
  background-color: #503DF6;
  color: #fff;
}

.rebut-container {
  padding-top: 24px;
  padding-bottom: 30px;
  position: relative;
  display: flex;
  justify-content: center;

  .chargeback-info {
    position: fixed;
    left: 116px;
  }

  .section {
    width: 532px;
    background-color: #FBFBFD !important;
  }

  .layer {
    // background-color: #FBFBFD !important;
  }
}

</style>
